import React from 'react';
import { REGIONS, COUNTRIES, getCitiesForCountry } from '@/utils/geoData';

/**
 * Sélecteur pays + ville avec autocomplétion (datalist) — Afrique, Europe, Amérique du Nord.
 * Formulaires de publication du colis et du trajet (direction C, `styles/publish-c.css`).
 * `errCountry` / `errCity` : message d'erreur affiché sous le champ (ou rien).
 */
export function CountryCitySelector({
  country, onCountryChange,
  city, onCityChange,
  dirLabel,
  errCountry, errCity,
}) {
  const cities = getCitiesForCountry(country);
  // Identifiants de test : « from » pour le départ, « to » pour l'arrivée
  const side = dirLabel === 'Départ' ? 'from' : 'to';
  const countryName = COUNTRIES.find((c) => c.code === country)?.name ?? '';
  const ids = { country: `pf-country-${side}`, city: `pf-city-${side}`, countries: `pf-countries-${side}`, cities: `pf-cities-${side}` };

  const handleCountryChange = (e) => {
    const val = e.target.value;
    const match = COUNTRIES.find((c) => c.name.toLowerCase() === val.toLowerCase());
    if (match) { onCountryChange(match.code); onCityChange(''); }
    else if (!val) { onCountryChange(''); onCityChange(''); }
  };

  return (
    <fieldset className="pf-place">
      <legend className="pf-label">{dirLabel}</legend>
      <div className="pf-place-row">
        <div className="pf-field">
          <label className="pf-sublabel" htmlFor={ids.country}>Pays</label>
          <input
            id={ids.country}
            className={`pf-input${errCountry ? ' is-err' : ''}`}
            list={ids.countries}
            placeholder="Saisir ou choisir un pays"
            data-testid={`input-country-${side}`}
            defaultValue={countryName}
            key={countryName}
            onChange={handleCountryChange}
            aria-invalid={errCountry ? 'true' : undefined}
            aria-describedby={errCountry ? `${ids.country}-err` : undefined}
          />
          <datalist id={ids.countries}>
            {REGIONS.map((region) => region.countries.map((c) => (
              <option key={c.code} value={c.name}>{region.label}</option>
            )))}
          </datalist>
          {errCountry && <p className="pf-err" id={`${ids.country}-err`}>{errCountry}</p>}
        </div>
        <div className="pf-field">
          <label className="pf-sublabel" htmlFor={ids.city}>Ville</label>
          <input
            id={ids.city}
            className={`pf-input${errCity ? ' is-err' : ''}`}
            list={ids.cities}
            placeholder={country ? 'Saisir ou choisir une ville' : "Choisissez d'abord le pays"}
            data-testid={`input-city-${side}`}
            value={city}
            disabled={!country}
            onChange={(e) => onCityChange(e.target.value)}
            aria-invalid={errCity ? 'true' : undefined}
            aria-describedby={errCity ? `${ids.city}-err` : undefined}
          />
          <datalist id={ids.cities}>
            {cities.map((c) => <option key={c} value={c} />)}
          </datalist>
          {errCity && <p className="pf-err" id={`${ids.city}-err`}>{errCity}</p>}
        </div>
      </div>
    </fieldset>
  );
}
